import { useState, useEffect, useRef } from "react";
import { assets } from "../mock";

const WelcomeOverlay = ({ onEnter }) => {
  const videoRef = useRef(null);
  const [leaving, setLeaving] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setReady(true), 250);
    return () => clearTimeout(t);
  }, []);

  const handleEnter = () => {
    setLeaving(true);
    setTimeout(() => onEnter(), 900);
  };

  return (
    <div className={`welcome ${leaving ? "welcome--leaving" : ""} ${ready ? "welcome--ready" : ""}`}>
      <video
        ref={videoRef}
        className="welcome-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        poster={assets.welcomePoster}
      >
        <source src={assets.welcomeVideo} type="video/mp4" />
      </video>
      <div
        className="welcome-image welcome-image--fallback"
        style={{ backgroundImage: `url(${assets.welcomePoster})` }}
      />
      <div className="welcome-veil" />
      <div className="welcome-grain" />

      <div className="welcome-inner">
        <div className="welcome-brand">
          <span className="welcome-brand__word">ODDA</span>
          <span className="welcome-brand__sub">Corp.</span>
        </div>
      </div>

      <div className="welcome-word">
        <span className="welcome-tag">Architecture · Design · Development</span>
        <button className="welcome-enter" onClick={handleEnter}>
          <span>Enter ODDA Corp.</span>
          <span className="welcome-enter__line" />
        </button>
      </div>

      <div className="welcome-corner welcome-corner--tl">ODDA / 01</div>
      <div className="welcome-corner welcome-corner--tr">MMXXV</div>
      <div className="welcome-corner welcome-corner--bl">Toronto · Canada</div>
      <div className="welcome-corner welcome-corner--br">Est. Studio</div>
    </div>
  );
};

export default WelcomeOverlay;
